type InputFieldProps = {
  label: string;
  value: string | number;
  onChange: (value: string) => void;
  type?: string;
  disabled?: boolean;
};

export const InputField = ({
  label,
  value,
  onChange,
  type = "text",
  disabled = false,
}: InputFieldProps) => (
  <div className="space-y-2">
    <label className="text-[#6b6b6b] text-[14px]">{label}</label>
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`w-full h-[42px] text-[14px] box-border px-4 py-2 border border-[#e0e0e0] rounded-lg ${
        disabled ? 'bg-[#f5f5f5] text-[#6b6b6b] cursor-not-allowed' : ''
      }`}
    />
  </div>
);